import { Navigate, useRoutes } from "react-router-dom";
import { paths } from "./paths";
import Home from "../pages/Home/Home";
import React, { Suspense } from "react";
import Loader from "@src/components/Loader/Loader";
import { useAiConfidencePageEnabled } from "@src/hooks/useAiConfidencePageEnabled";

const LazyEvents = React.lazy(() => import("@src/pages/Events/Events").then((x) => ({ default: x.Events })));
const LazyReports = React.lazy(() => import("@src/pages/Reports/Reports").then((x) => ({ default: x.Reports })));
const LazyPOMapping = React.lazy(() => import("@src/pages/POMapping/POMapping").then((x) => ({ default: x.POMapping })));
const LazyVenueAliases = React.lazy(() => import("@src/pages/VenueAliases/VenueAliases").then((x) => ({ default: x.VenueAliases })));
const LazyAiConfidence = React.lazy(() => import("@src/pages/AiConfidence/AiConfidence").then((x) => ({ default: x.AiConfidence })));

export const Routes = () => {
	const isAiConfidenceEnabled = useAiConfidencePageEnabled();

	return useRoutes([
		{
			path: paths.home,
			element: <Home />,
			children: [
				{
					index: true,
					element: (
						<Suspense fallback={<Loader controlSize="xxl" />}>
							<LazyEvents />
						</Suspense>
					),
				},
				{
					path: paths.reports.slice(1),
					element: (
						<Suspense fallback={<Loader controlSize="xxl" />}>
							<LazyReports />
						</Suspense>
					),
				},
				{
					path: paths.poMapping,
					element: (
						<Suspense fallback={<Loader controlSize="xxl" />}>
							<LazyPOMapping />
						</Suspense>
					),
				},
				{
					path: paths.venueAliases.slice(1),
					element: (
						<Suspense fallback={<Loader controlSize="xxl" />}>
							<LazyVenueAliases />
						</Suspense>
					),
				},
				{
					path: paths.aiConfidence.slice(1),
					element: isAiConfidenceEnabled ? (
						<Suspense fallback={<Loader controlSize="xxl" />}>
							<LazyAiConfidence />
						</Suspense>
					) : (
						<Navigate to={paths.home} replace />
					),
				},
			],
		},
	]);
};
